<template>
  <div class="classItem">
    <div class="img"
      :style="{backgroundImage: `url('${thumb}')`}"
      @click="setDetailGroupItemGallery($event)">
      <button
        type="button"
        class="btnDelete"
        @click.stop="$emit('deleteItem', groupOrderItemId)">
        DELETE
      </button>
    </div>
    <div class="name">{{ item.collectionItemName[lang] }}</div>
  </div>
</template>

<script>
export default {
  name: 'CollectionGroupItem',
  props: [
    'locale',
    'lang',
    'categoryId',
    'item',
    'isChecked',
    'isCompareItem',
    'groupOrderItemId'
  ],
  computed: {
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    thumb () {
      return this.item.attribute.image
    }
  },
  methods: {
    setDetailGroupItemGallery(e) {
      e.stopPropagation()
      this.$emit('setDetailGroupItemGallery', {
        subItemId: this.item.subItemId
      })
    }
  }
}
</script>